import { createAsyncThunk, current } from '@reduxjs/toolkit';
import axios from 'axios';
import { axiosAdmin } from '../../../utils/axiosUser';

export const initStateClubSingle = {
  clubSingle: { data: null, loading: false, error: null },
};

export const clubSingle = createAsyncThunk('user/clubSingle', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosAdmin
    .get(`/club/${data.id}`, {
      params: data,
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerClubSingle = {
  [clubSingle.pending]: (state) => {
    state.clubSingle.loading = true;
  },
  [clubSingle.fulfilled]: (state, action) => {
    state.clubSingle.loading = false;
    state.clubSingle.data = action.payload;
    state.clubSingle.error = null;
  },
  [clubSingle.rejected]: (state, action) => {
    state.clubSingle.data = null;
    state.clubSingle.loading = false;
    state.clubSingle.error = action.payload;
  },
};
